import type { Component, VNode } from "vue";

export function isDescendant(parent: Node, child: Node) {
    let node = child.parentNode;
    while (node != null) {
        if (node === parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

export function getAllEventNames(keepEventPrefix?: boolean) {
    const documentPropertyNames = Object.getOwnPropertyNames(document);
    const prototypeOf = Object.getPrototypeOf(Object.getPrototypeOf(document));
    const ownPropertyNames = Object.getOwnPropertyNames(prototypeOf);
    const documentPropertyNames2 =
        documentPropertyNames.concat(ownPropertyNames);

    /*
    let windowProperties = Object.getOwnPropertyNames(Object.getPrototypeOf(window));
    documentPropertyNames2 = documentPropertyNames2.concat(windowProperties);
    */

    const result = documentPropertyNames2.filter(function (i) {
        return (
            !i.indexOf("on") &&
            ((document as any)[i] == null ||
                typeof (document as any)[i] === "function")
        );
    });

    /*
    result = result.filter(function(elem, pos, self) {
        return self.indexOf(elem) == pos;
    });
    */

    if (keepEventPrefix === true) return result;
    return result.map((x) => x.substr(2));
}

export function bindAllEvents(
    element: Element,
    handler: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions | undefined
) {
    const allEvents = getAllEventNames();
    for (let i = 0; i < allEvents.length; i++) {
        if (options != null)
            element.addEventListener(allEvents[i], handler, options);
        else element.addEventListener(allEvents[i], handler);
    }
}

export function isVueElement(element: Element, iterate = true): boolean {
    if (
        ("__vueParentComponent" in element &&
            element.__vueParentComponent != null) ||
        ("__vnode" in element && element.__vnode != null) ||
        getVueComponentInstance(element) != null
    )
        return true;
    if (iterate === true && element.parentElement != null)
        return isVueElement(element.parentElement);
    return false;
}

export function getVueComponentInstance(element: Element) {
    const el = element as unknown as {
        __vue__?: null | undefined | Component;
        __vnode: VNode & { ctx: null | undefined | Component };
    };
    return el?.__vue__ ?? el?.__vnode?.ctx;
}
